//Количество символов
export default {
    methods: {
        accordion(reference, parent) {
            /**
                * Arguments:
                * reference - ссылка на блок в формате vue ref,
                * parent - если есть вложенный аккордион (работает для структуры типа "заказ")
             */
            
            let height = ''
            let parentHeight = ''
                
            height = this.$refs[reference].firstChild.offsetHeight
            
            if (parent) {
                parentHeight = this.$refs[parent].offsetHeight
            }

            if (!this.$refs[reference].classList.contains('js-accordion-open')) {
                this.$refs[reference].style.height = height + 'px'

                if (parent) {
                    this.$refs[parent].style.height = parentHeight + height + 'px'
                }

                this.$refs[reference].classList.toggle('js-accordion-open')
            } else {
                this.$refs[reference].style.height = ''

                if (parent) {
                    this.$refs[parent].style.height = parentHeight - height + 'px' 
                }

                this.$refs[reference].classList.toggle('js-accordion-open')
            }
        }
    }
}